/**
 * @param form {HTMLFormElement}
 * @param region {"US" | "UK" | "EMEA"}
 * @return {void}
 */
module.exports = function Form_showPrivacyPolicyForRegion(form, region) {
    const privacyPolicy = form.querySelector('[data-component="PrivacyPolicy"]');
    if (privacyPolicy instanceof HTMLElement) {
        privacyPolicy.style.display = "";
    }

    const privacyPolicyCheckboxWrap = form.querySelector('[data-component="PrivacyPolicyCheckbox"]');
    if (privacyPolicyCheckboxWrap instanceof HTMLElement) {
        if (region === "US") {
            privacyPolicyCheckboxWrap.style.display = "none";
        } else {
            privacyPolicyCheckboxWrap.style.display = "";
        }
    }

    const privacyPolicyPartnerCheckboxWrap = form.querySelector('[data-component="PrivacyPolicyPartnerCheckbox"]');
    if (privacyPolicyPartnerCheckboxWrap instanceof HTMLElement) {
        if (region === "US" || region === "UK") {
            privacyPolicyPartnerCheckboxWrap.style.display = "none";
        } else {
            privacyPolicyPartnerCheckboxWrap.style.display = "";
        }
    }

    const privacyPolicyPartnerCheckbox = form.querySelector('[name="partnerMarketingOptIn"]');
    if (privacyPolicyPartnerCheckbox instanceof HTMLInputElement) {
        privacyPolicyPartnerCheckbox.checked = false;
    }

    const privacyPolicyCheckbox = form.querySelector('[name="marketingConsent"]');
    if (privacyPolicyCheckbox instanceof HTMLInputElement) {
        privacyPolicyCheckbox.checked = false;
    }

    const privacyPolicyMessage_US = form.querySelector('[data-component="PrivacyPolicyMessage_US"]');
    if (privacyPolicyMessage_US instanceof HTMLElement) {
        if (region === "US") {
            privacyPolicyMessage_US.style.display = "";
        } else {
            privacyPolicyMessage_US.style.display = "none";
        }
    }

    const privacyPolicyMessage_UK = form.querySelector('[data-component="PrivacyPolicyMessage_UK"]');
    if (privacyPolicyMessage_UK instanceof HTMLElement) {
        if (region === "UK") {
            privacyPolicyMessage_UK.style.display = "";
        } else {
            privacyPolicyMessage_UK.style.display = "none";
        }
    }

    const privacyPolicyMessage_EMEA = form.querySelector('[data-component="PrivacyPolicyMessage_EMEA"]');
    if (privacyPolicyMessage_EMEA instanceof HTMLElement) {
        if (region === "US" || region === "UK") {
            privacyPolicyMessage_EMEA.style.display = "none";
        } else {
            privacyPolicyMessage_EMEA.style.display = "";
        }
    }
}